<div [className]="classes"
     class="size">
    <button>
      <img [src]="src" [alt]="alt" class="w-full h-full object-contain" />
    </button>
</div>
